import axios from 'axios';

// const API_BASE_URL = 'https://liveapi.salestrackify.com/api/'; // Replace with your API base URL

export const API_BASE_URL = 'https://demoapi.salestrackify.com/api/'

export const getData = async (endpoint: string) => {

    const getFullUrl = (endpoint: any) => `${API_BASE_URL}${endpoint}`;

    try {
        const url = getFullUrl(endpoint);
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*',
            },
        });

        if (!response.ok) {

            throw new Error(`HTTP Error: ${response.status} ${response.statusText}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {

        if (error instanceof Error) {

            console.error('Error:', error.message);
        } else if (error instanceof TypeError) {

            console.error('Network Error:', error.message);
        } else {

            console.error('Unexpected error:', error);
        }
        throw error;
    }
};


export const postData = async (endpoint: any, payload: any) => {
    const getFullUrl = (endpoint: any) => `${API_BASE_URL}${endpoint}`;

    try {
        const url = getFullUrl(endpoint);
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*',
            },
            body: JSON.stringify(payload),
        });

        if (!response.ok) {
            throw new Error(`HTTP Error: ${response.status} ${response.statusText}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        if (error instanceof Error) {
            console.error('Error:', error.message);
        } else if (error instanceof TypeError) {
            console.error('Network Error:', error.message);
        } else {
            console.error('Unexpected error:', error);
        }
        throw error;
    }
};
